export default (props, { t }) => ({
  title: t('meta', 'login.title'),
});
